document.addEventListener('DOMContentLoaded', () => {
  console.log('👉 monogram-init.js loaded');

  // --- Elements / Context -------------------------------------------------
  const openBtn = document.getElementById('open-monogram');
  if (!openBtn) return console.warn('No #open-monogram button');

  const wrapper = openBtn.closest('[data-monogram-logos]');
  if (!wrapper) return console.warn('No data-monogram-logos wrapper');

  const modal    = document.getElementById('monogram-modal');
  const closeBtn = modal.querySelector('.monogram-close');
  const steps    = Array.from(modal.querySelectorAll('.monogram-step'));

  // Buttons
  const nextLogo   = modal.querySelector('#logo-next');
  const nextReview = modal.querySelector('#review-next');
  const confirmBtn = modal.querySelector('#monogram-confirm');

  // --- Utils --------------------------------------------------------------
  const formatMoneyNoTrailingZeros = (amt) => {
    const n = Number(amt);
    if (!isFinite(n)) return '0';
    const s = n.toFixed(2);
    if (s.endsWith('.00')) return s.slice(0, -3);
    if (s.endsWith('0'))   return s.slice(0, -1);
    return s;
  };

  // --- Data: Logos --------------------------------------------------------
  let logos;
  try {
    logos = JSON.parse(wrapper.dataset.monogramLogos);
    if (typeof logos === 'string') logos = JSON.parse(logos);
  } catch {
    console.error('❌ Could not parse logos JSON');
    logos = [];
  }
  if (!Array.isArray(logos)) logos = Object.values(logos || {});
  console.log('✅ logos:', logos);

  // --- Schools (derive from logos) ---------------------------------------
  const schools = Array.from(new Set((logos || []).map(l => l && l.school).filter(Boolean)));
  const schoolGridEl   = modal.querySelector('#school-grid');
  const schoolWrapEl   = modal.querySelector('#school-select-wrap');
  const schoolSelectEl = modal.querySelector('#school-select');
  const schoolNextEl   = modal.querySelector('#school-next');

  const enableSchoolStep = schools.length > 1;
  let chosenSchool = null;

  // Grid ≤ 6, dropdown ≥ 7
  const DROPDOWN_THRESHOLD = 6;
  if (enableSchoolStep) {
    if (schools.length > DROPDOWN_THRESHOLD) {
      // dropdown mode
      if (schoolWrapEl) {
        schoolWrapEl.hidden = false;
        schoolSelectEl.innerHTML =
          `<option value="" selected disabled>Select a school</option>` +
          schools.map(s => `<option value="${s}">${s}</option>`).join('');
      }
    } else {
      // grid mode
      if (schoolGridEl) {
        schoolGridEl.hidden = false;
        schoolGridEl.innerHTML = schools.map((name, i) => `
          <div class="school-card" tabindex="0" data-index="${i}" aria-selected="false">
            <p>${name}</p>
          </div>
        `).join('');
      }
    }
  }

  // --- Placements ---------------------------------------------------------
  let placements;
  try {
    placements = JSON.parse(wrapper.dataset.monogramPlacements || '[]');
    if (typeof placements === 'string') placements = JSON.parse(placements);
  } catch {
    placements = [];
  }
  if (!Array.isArray(placements)) placements = Object.values(placements || {});
  if (!placements.length) placements = ['Left Chest', 'Left Sleeve', 'Nape of Neck'];
  console.log('📍 placements:', placements);

  const placementsFieldset = modal.querySelector('#placement-options');
  if (placementsFieldset) {
    placementsFieldset.innerHTML = placements.map((p, idx) => {
      const id = `placement_${idx}`;
      const safe = String(p);
      return `
        <label for="${id}">
          <input id="${id}" type="radio" name="placement" value="${safe}">
          ${safe}
        </label>
      `;
    }).join('');
  }

  // --- Fee (robust parse + conditional UI) --------------------------------
  const rawFee   = wrapper.dataset.monogramFee; // may be "0", "25", "$25", etc.
  const feeFloat = parseFloat(String(rawFee || '0').replace(/[^0-9.]+/g, ''));
  const feeOk    = Number.isFinite(feeFloat) ? feeFloat : 0;
  const feeDisp  = formatMoneyNoTrailingZeros(feeOk);

  // Modal title text
  const titleEl  = modal.querySelector('.monogram-title');
  if (titleEl) {
    // Adjust copy to your preference
    titleEl.textContent = feeOk > 0
      ? `ADD SCHOOL LOGO (+$${feeDisp})`
      : 'ADD SCHOOL LOGO';
  }

  // Review step: hide fee line when zero (ensure <li class="review-fee">…)
  const feeLi = modal.querySelector('.review-fee');
  if (feeLi) feeLi.style.display = feeOk > 0 ? '' : 'none';

  // --- Step mechanics -----------------------------------------------------
  const grid = modal.querySelector('#logo-grid');
  let visibleLogos = Array.isArray(logos) ? logos : [];
  let chosenLogo = null;

  function renderLogos(list) {
    visibleLogos = list || [];
    if (!grid) return;
    grid.innerHTML = visibleLogos.map((l,i) => `
      <div class="logo-card" tabindex="0" data-index="${i}" aria-selected="false">
        <img src="${l.image}" alt="${l.name}" />
        <p>${l.name}</p>
      </div>
    `).join('');
    chosenLogo = null;
    if (nextLogo) nextLogo.disabled = true;
  }
  renderLogos(visibleLogos);

  function goTo(n) {
    steps.forEach(s => s.classList.add('hidden'));
    modal.querySelector(`.monogram-step[data-step="${n}"]`)?.classList.remove('hidden');
  }

  // Open / Close
  openBtn.addEventListener('click', () => {
    if (nextLogo)   nextLogo.disabled   = true;
    if (nextReview) nextReview.disabled = true;
    goTo(enableSchoolStep ? 0 : 1);
    modal.classList.remove('hidden');

    // Back visibility on Step 1 only if Step 0 exists
    const logoBackBtn = modal.querySelector('#logo-back');
    if (logoBackBtn) logoBackBtn.style.display = enableSchoolStep ? '' : 'none';
  });
  closeBtn?.addEventListener('click', () => modal.classList.add('hidden'));

  // Step 0: interactions
  if (enableSchoolStep) {
    schoolGridEl?.addEventListener('click', (e) => {
      const card = e.target.closest('.school-card');
      if (!card) return;
      schoolGridEl.querySelectorAll('.school-card').forEach(x => x.setAttribute('aria-selected','false'));
      card.setAttribute('aria-selected','true');
      chosenSchool = schools[+card.dataset.index];

      const filtered = (logos || []).filter(l => l.school === chosenSchool);
      renderLogos(filtered);
      if (schoolNextEl) schoolNextEl.disabled = false;
    });

    schoolSelectEl?.addEventListener('change', () => {
      chosenSchool = schoolSelectEl.value || null;
      const filtered = (logos || []).filter(l => l.school === chosenSchool);
      renderLogos(filtered);
      if (schoolNextEl) schoolNextEl.disabled = !chosenSchool;
    });

    schoolNextEl?.addEventListener('click', () => goTo(1));
  }

  // Inject help line under Step-1 title (no Liquid edits)
  (() => {
    const step1 = modal.querySelector('.monogram-step[data-step="1"]');
    if (!step1 || step1.querySelector('.monogram-help')) return;
    const step1Title = step1.querySelector('.monogram-step-title');
    if (!step1Title) return;
    step1Title.insertAdjacentHTML(
      'afterend',
      '<p class="monogram-help">Please contact <a href="mailto:support@campuscourse.com">support@campuscourse.com</a> if you are interested in adding multiple logos to your custom polo.</p>'
    );
  })();

  // Step 1: logo selection
  grid?.addEventListener('click', (e) => {
    const card = e.target.closest('.logo-card');
    if (!card) return;
    grid.querySelectorAll('.logo-card').forEach(x => x.setAttribute('aria-selected','false'));
    card.setAttribute('aria-selected','true');
    chosenLogo = visibleLogos[+card.dataset.index];
    if (nextLogo) nextLogo.disabled = !chosenLogo;
  });

  // Step 1 -> Step 2
  nextLogo?.addEventListener('click', () => goTo(2));

  // Back (single handler; capture so it wins if something else bound earlier)
  modal.addEventListener('click', (e) => {
    const back = e.target.closest('.monogram-prev');
    if (!back) return;
    e.stopImmediatePropagation();
    e.stopPropagation();
    const current = +modal.querySelector('.monogram-step:not(.hidden)')?.dataset.step || 1;
    const minStep = enableSchoolStep ? 0 : 1;
    goTo(Math.max(minStep, current - 1));
  }, { capture: true });

  // Step 2: enable Review when placement selected
  modal.querySelectorAll('input[name="placement"]').forEach(r =>
    r.addEventListener('change', () => { if (nextReview) nextReview.disabled = false; })
  );

  // Step 2 -> Step 3 (Review)
  nextReview?.addEventListener('click', () => {
    const placement = modal.querySelector('input[name="placement"]:checked')?.value || '';
    const logoEl   = modal.querySelector('[data-review="logoName"]');
    const placeEl  = modal.querySelector('[data-review="placement"]');
    const feeEl    = modal.querySelector('[data-review="fee"]');
    const schoolEl = modal.querySelector('[data-review="school"]');
    const schoolLi = schoolEl?.closest('li');

    if (logoEl)  logoEl.textContent  = chosenLogo?.name || '';
    if (placeEl) placeEl.textContent = placement;
    if (feeEl)   feeEl.textContent   = formatMoneyNoTrailingZeros(feeOk);

    if (schoolEl && schoolLi) {
      if (chosenSchool) {
        schoolEl.textContent = chosenSchool;
        schoolLi.style.display = '';
      } else {
        schoolEl.textContent = '';
        schoolLi.style.display = 'none';
      }
    }
    goTo(3);
  });

  // --- Confirm: add to cart (with PDP fallback) --------------------------
  confirmBtn?.addEventListener('click', async () => {
    // quantity from PDP form
    const form = openBtn.closest('form.product-form');
    const qtyInput = form?.querySelector('input[name="quantity"]');
    let qty = parseInt(qtyInput?.value, 10);
    if (!Number.isFinite(qty) || qty < 1) qty = 1;

    // optional hints
    const twinHandle    = wrapper.dataset.monogramTwinHandle;
    const directVariant = wrapper.dataset.monogramVariant;

    // current PDP variant id (for fallback)
    const mainVariantInput = document.querySelector('input[name="id"][form^="ProductForm"]');
    const mainVarId = mainVariantInput?.value ? Number(mainVariantInput.value) : null;

    let variantIdToAdd = null;

    if (twinHandle) {
      // Try to match PDP variant options to twin product
      try {
        const res = await fetch(`/products/${twinHandle}.js`);
        const twinProduct = await res.json();

        const mainJSON = JSON.parse(document.querySelector('script[data-product-json]').textContent);
        const mainVar  = mainJSON.variants.find(v => v.id == mainVarId) || mainJSON.variants[0];

        const match = twinProduct.variants.find(tv =>
             tv.option1 === mainVar.option1
          && (tv.option2 || '') === (mainVar.option2 || '')
          && (tv.option3 || '') === (mainVar.option3 || '')
        ) || twinProduct.variants[0];

        variantIdToAdd = match?.id ?? null;
      } catch (e) {
        console.error('❌ could not fetch/match twin product', e);
      }
    } else if (directVariant) {
      variantIdToAdd = Number(directVariant);
    } else {
      // NEW: fallback to current PDP variant
      variantIdToAdd = mainVarId;
    }

    if (!variantIdToAdd) {
      console.error('⚠️ No variant to add (twin/direct/main missing)');
      return closeBtn?.click();
    }

    const placement = modal.querySelector('input[name="placement"]:checked')?.value || '';
    const props = {
      "Logo":      (chosenLogo?.name || ''),
      "Placement": placement
    };
    if (typeof chosenSchool === 'string' && chosenSchool) props["School"] = chosenSchool;
    if (feeOk > 0) props["Cost"] = `$${formatMoneyNoTrailingZeros(feeOk)}`;

    try {
      const resp = await fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [{
            id: variantIdToAdd,
            quantity: qty,
            properties: props
          }]
        })
      });
      if (!resp.ok) throw new Error(await resp.text());
      window.location.reload();
    } catch (err) {
      console.error('❌ Add to cart failed:', err);
      closeBtn?.click();
    }
  });
});
